import { createRoutine } from 'redux-saga-routines';
import { createDocumentCacheRoutine } from '../Documents/routines';

export const getPatientTemplatesRoutine = createRoutine('GET_IMAGES_PATIENT_TEMPLATES');

export const getTemplatesRoutine = createRoutine('GET_IMAGES_TEMPLATES');

export const getTemplateRoutine = createRoutine('GET_IMAGES_TEMPLATE');

export const templateCacheRoutine = createDocumentCacheRoutine('TEMPLATE_CACHE')